import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

const agencyFilterBlock = document.querySelector('.agency-filter-block')
export const BOOKINGS_DEFAULT_ORDER = 'near_to_checkin_date'
const INPUT_FORMAT = $('html').attr('data-date-format')

const DATE_TYPES = {
  arrival: 'arrival',
  booking: 'booking',
}

const parseInputDate = value => {
  let dateFormat = dayjs(value, INPUT_FORMAT, true)
  if (dateFormat.isValid()) return dateFormat
  /* If the user has 'MM/DD/YYYY' date format */
  const altFormat = INPUT_FORMAT === 'DD/MM/YYYY' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
  dateFormat = dayjs(value, altFormat, true)
  return dateFormat
}

export const getFilterValues = (page, perPage, outputFormat = INPUT_FORMAT) => {
  if (!agencyFilterBlock) return {}

  const startRaw = agencyFilterBlock.querySelector('.js-filter-start-date')?.value || ''
  const endRaw = agencyFilterBlock.querySelector('.js-filter-end-date')?.value || ''

  const start = startRaw ? parseInputDate(startRaw) : null
  const end = endRaw ? parseInputDate(endRaw) : null

  const selectedDateType = agencyFilterBlock.querySelector('.js-filter-date-type')?.value || ''
  const clientName = agencyFilterBlock.querySelector('#client_name').value
  const hotelId = agencyFilterBlock.querySelector('#hotel_id').value
  const bookingCode = agencyFilterBlock.querySelector('#booking_code').value

  const filterValues = {
    ...(hotelId ? { hotel_id: hotelId } : {}),
    ...(bookingCode ? { booking_code: bookingCode } : {}),
    ...(selectedDateType === DATE_TYPES.arrival && start?.isValid()
      ? { with_arrival_date_start: start.format(outputFormat) }
      : {}),
    ...(selectedDateType === DATE_TYPES.arrival && end?.isValid()
      ? { with_arrival_date_end: end.format(outputFormat) }
      : {}),
    ...(selectedDateType === DATE_TYPES.booking && start?.isValid()
      ? { with_booking_date_start: start.format(outputFormat) }
      : {}),
    ...(selectedDateType === DATE_TYPES.booking && end?.isValid()
      ? { with_booking_date_end: end.format(outputFormat) }
      : {}),
    with_book_status: Boolean(agencyFilterBlock.querySelector('#with_book_status:checked')),
    with_cancel_status: Boolean(agencyFilterBlock.querySelector('#with_cancel_status:checked')),
    with_pending_status: Boolean(agencyFilterBlock.querySelector('#with_pending_status:checked')),
    with_payment_paid: Boolean(agencyFilterBlock.querySelector('#with_payment_paid:checked')),
    with_payment_unpaid: Boolean(agencyFilterBlock.querySelector('#with_payment_unpaid:checked')),
    ...(clientName ? { client_name: clientName } : {}),
    order_by: BOOKINGS_DEFAULT_ORDER,
    ...(page ? { page } : {}),
    ...(perPage ? { per_page: perPage } : {}),
  }
  return filterValues
}

export const getFilterValuesSerialized = () => {
  const filterValues = getFilterValues()
  return new URLSearchParams(filterValues).toString()
}
